/**
 * Which site group a site is being viewed under.
 *
 * The site dashboard route names the group in its URL. Surfaces that open a
 * site without one — the customer map's detail panel — only learn it from the
 * site snapshot, whose `owner` is the site's primary group. This decides which
 * group the legacy selected-plant slice should hold, so both entry points feed
 * the same group to the affordances that read it.
 *
 * Returns plain JS — no JSX, no redux.
 */

/**
 * Resolves the site group to select, or null when nothing should be selected.
 *
 * A route that names the group owns the answer, so this returns null and the
 * route's own value stands. Without one, the site's primary group stands in,
 * and only once the snapshot has resolved it.
 *
 * @param {?(string|number)} routeSiteGroupId - `sitegroup_id` from the route params.
 * @param {?object} site - the site snapshot, or null before it resolves.
 * @returns {?(string|number)} the group id to select, or null for "leave it alone".
 */
export function resolveDerivedSiteGroupId(routeSiteGroupId, site) {
  if (routeSiteGroupId != null) return null;
  return site?.owner?.id ?? null;
}
